import { Card, CardHeader, CardContent, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  pageWrapper: {
    margin: "50px auto",
    width: "100%",
    maxWidth: "800px"
  }
}));

export default function LoginErrorLayout({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.pageWrapper}>
      <Card>
        <CardHeader title={title} />
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
}
